// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/* purgecss start ignore */\n\n.activeLanguage{\n  color: #018ccf !important;\n}\n\n/* purgecss end ignore */", "",{"version":3,"sources":["<no source>","styles.css"],"names":[],"mappings":"AAAA,2BAAA;;ACCA;EACI,yBAAyB;AAC7B;;ADHA,yBAAA","file":"styles.css","sourcesContent":[null,"\n.activeLanguage{\n    color: #018ccf !important;\n}"]}]);
// Exports
module.exports = exports;
